<template>
  <b-table
    :data="factors"
    ref="table"
    detailed
    hoverable
    :sticky-header="true"
    narrowed
    striped
    :has-detailed-visible="hasDecomposition"
    icon-pack="fa"
    custom-detail-row
    :show-detail-icon="true"
  >
    <b-table-column
      v-slot="props"
      :label="$t('compCarbonDocsEmissionsFactorsTable.label-1')"
    >
      {{ $t(props.row.category) }}
    </b-table-column>
    <b-table-column
      v-slot="props"
      :label="$t('compCarbonDocsEmissionsFactorsTable.label-2')"
    >
      {{ $t(props.row.subcategory) }}
    </b-table-column>
    <b-table-column :label="$t('compCarbonDocsEmissionsFactorsTable.label-3')">
      <template v-slot="props">
        <span v-if="$t(props.row.subsubcategory).length < 20">
          {{ $t(props.row.subsubcategory) }}
        </span>
        <span v-else>
          <b-tooltip
            multilined
            :label="$t(props.row.subsubcategory)"
            type="is-black"
          >
            {{ $t(props.row.subsubcategory) | truncate(20) }}
          </b-tooltip>
        </span>
      </template>
    </b-table-column>
    <b-table-column
      v-slot="props"
      :label="$t('compCarbonDocsEmissionsFactorsTable.label-4')"
    >
      {{ $t(props.row.unit) }}
    </b-table-column>
    <b-table-column>
      <template v-slot:header>
        {{ $t('compCarbonDocsEmissionsFactorsTable.label-6') }}
      </template>
      <template v-slot="props">
        <span v-if="getDescription(props.row).length < 20">
          {{ getDescription(props.row) }}
        </span>
        <span v-else>
          <b-tooltip
            multilined
            :label="getDescription(props.row)"
            type="is-black"
          >
            {{ getDescription(props.row) | truncate(20) }}
          </b-tooltip>
        </span>
      </template>
    </b-table-column>
    <b-table-column v-slot="props" :label="$t('year')">
      {{ props.row.getYear() }}
    </b-table-column>
    <b-table-column :label="$t('compCarbonDocsEmissionsFactorsTable.label-8')">
      {{ $t('compCarbonDocsEmissionsFactorsTable.label-9') }}
    </b-table-column>
    <b-table-column numeric v-slot="props" label="CO2">
      {{ props.row.getFactor().total.co2 }}
    </b-table-column>
    <b-table-column numeric v-slot="props" label="CH4">
      {{ props.row.getFactor().total.ch4 }}
    </b-table-column>
    <b-table-column numeric v-slot="props" label="N2O">
      {{ props.row.getFactor().total.n2o }}
    </b-table-column>
    <b-table-column
      numeric
      v-slot="props"
      :label="$t('compCarbonDocsEmissionsFactorsTable.label-10')"
    >
      {{ props.row.getFactor().total.other }}
    </b-table-column>
    <b-table-column
      numeric
      v-slot="props"
      :label="$t('compCarbonDocsEmissionsFactorsTable.label-12')"
    >
      {{ props.row.getFactor().total.total }}
    </b-table-column>
    <b-table-column
      v-slot="props"
      :label="$t('compCarbonDocsEmissionsFactorsTable.label-11')"
    >
      {{ $t('kg.co2e') }}/{{ $t(props.row.unit) }}
    </b-table-column>
    <b-table-column
      numeric
      v-slot="props"
      :label="$t('compCarbonDocsEmissionsFactorsTable.label-14')"
    >
      {{ props.row.group }}
    </b-table-column>
    <b-table-column
      numeric
      v-slot="props"
      :label="$t('compCarbonDocsEmissionsFactorsTable.label-13')"
    >
      {{ props.row.getFactor().total.uncertainty * 100 }} %
    </b-table-column>
    <template slot="detail" slot-scope="props">
      <tr
        v-for="(dec, index) in props.row.getDecompositionKeys()"
        :key="Math.floor(Math.random() * 100000000) + index"
      >
        <td
          v-if="index == 1"
          :rowspan="props.row.getDecompositionKeys().length - 1"
          colspan="7"
          style="border-right: 1px solid #dbdbdb"
        ></td>
        <td v-if="index > 0">{{ $t(dec) }}</td>
        <td v-if="index > 0" class="has-text-right">
          {{ props.row.getFactor()[dec].co2 }}
        </td>
        <td v-if="index > 0" class="has-text-right">
          {{ props.row.getFactor()[dec].ch4 }}
        </td>
        <td v-if="index > 0" class="has-text-right">
          {{ props.row.getFactor()[dec].n2o }}
        </td>
        <td v-if="index > 0" class="has-text-right">
          {{ props.row.getFactor()[dec].other }}
        </td>
        <td v-if="index > 0" class="has-text-right">
          {{ props.row.getFactor()[dec].total }}
        </td>
        <td v-if="index > 0">
          {{ $t('kg.co2e') }}/{{
            $t('compCarbonDocsEmissionsFactorsTable.' + props.row.unit)
          }}
        </td>
        <td v-if="index > 0" class="has-text-right">{{ props.row.group }}</td>
        <td v-if="index > 0" class="has-text-right">
          {{ props.row.getFactor()[dec].uncertainty * 100 }} %
        </td>
      </tr>
    </template>
  </b-table>
</template>

<script>
export default {
  name: 'EmissionsFactorsTable',
  props: {
    factors: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    hasDecomposition: function (row) {
      return row.hasDecomposition()
    },
    getDescription: function (factor) {
      return factor['description' + this.$i18n.locale.toUpperCase()]
    }
  }
}
</script>

<style>
.b-table .table-wrapper.has-sticky-header {
  height: 560px !important;
  overflow-y: auto;
}
</style>
